<template>
<div id="app">
  <div  class="d-cont mx-auto px-6">
  <div class="header">
    Face Recognition
  </div>
  <progress class="d-progress" :value="page" max="2"></progress>
  
    <div class="body">
      <div class="d-box"  v-if="page==0" style="display:block;">
        <div class="body">
          <div class="content">
            <h1>Model of Face Recognition</h1>
          </div>
          <div class="footer">
            <button class="btn" @click="nextPage"><span class="text-lg">START</span></button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-game" v-if="page ==1" style="display:block;">
        <div class="body">
          <div class="d-header">
              <h4><strong>The model of face recognition proposed by Bruce and Young (1986)</strong></h4><br>
              <h5 style="margin-top:-20px;">Drag and drop the textual descriptions to their correct locations within the model</h5>
          </div>
          <div class="target">
              <!-- <table class="py-2"> -->
                  
                   <div class="row griddy">
                     <div class="col-sm-10 dropboxes">
                     <img id="img1" src="images/structure.png">
                      <draggable class='dropbox-cont1' :options="{animation:200}"  v-model="destination[1]" group="destinations" @end="drag=false" @change="checkBox">
                        <div :class="'destination[1] !== null' ? 'd-active droptarget1' : 'droptarget1'" id="target1">
                          <div class="dragcont" v-for="(box, key) in destination[1]" :key="key">
                            <li class="text-box">{{ box.name }}</li>
                          </div>
                        </div>
                      </draggable>
                      <draggable class='dropbox-cont2' :options="{animation:200}"  v-model="destination[2]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[2] !== null' ? 'd-active droptarget2' : 'droptarget2'" id="target2">
                          <div class="dragcont" v-for="(box, key) in destination[2]" :key="key">
                           <li class="text-box">{{ box.name }}</li>
                          </div>
                        </div>
                      </draggable>
                       
                      <draggable class='dropbox-cont3' :options="{animation:200}"  v-model="destination[3]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[3] !== null' ? 'd-active droptarget3' : 'droptarget3'" id="target3">
                          <div class="dragcont" v-for="(box, key) in destination[3]" :key="key">
                            <li class="text-box">{{ box.name }}</li>
                          </div>
                        </div>
                      </draggable>
                      
                      <draggable class='dropbox-cont4' :options="{animation:200}"  v-model="destination[4]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[4] !== null' ? 'd-active droptarget4' : 'droptarget4'" id="target4">
                          <div class="dragcont" v-for="(box, key) in destination[4]" :key="key">
                            <li class="text-box">{{ box.name }}</li>
                          </div>
                        </div>
                      </draggable>
                      
                      <draggable class='dropbox-cont5' :options="{animation:200}"  v-model="destination[5]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[5] !== null' ? 'd-active droptarget5' : 'droptarget5'" id="target5">
                          <div class="dragcont" v-for="(box, key) in destination[5]" :key="key">
                            <span class="text-box">{{ box.name }}</span>
                          </div>
                        </div>
                      </draggable>
                      <draggable class='dropbox-cont6' :options="{animation:200}"  v-model="destination[6]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[6] !== null' ? 'd-active droptarget6' : 'droptarget6'" id="target6">
                          <div class="dragcont" v-for="(box, key) in destination[6]" :key="key">
                            <span class="text-box">{{ box.name }}</span>
                          </div>
                         
                        </div>
                      </draggable>
                       
                      <draggable class='dropbox-cont7' :options="{animation:200}"  v-model="destination[7]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[7] !== null' ? 'd-active droptarget7' : 'droptarget7'" id="target7">
                          <div class="dragcont" v-for="(box, key) in destination[7]" :key="key">
                            <span class="text-box">{{ box.name }}</span>
                          </div>
                         
                        </div>
                      </draggable>

                      <draggable class='dropbox-cont8' :options="{animation:200}"  v-model="destination[8]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[8] !== null' ? 'd-active droptarget8' : 'droptarget8'" id="target8">
                          <div class="dragcont" v-for="(box, key) in destination[8]" :key="key">
                            <span class="text-box">{{ box.name }}</span>
                          </div>
                        </div>
                      </draggable>
                       
                      <draggable class='dropbox-cont9' :options="{animation:200}"  v-model="destination[9]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                        <div :class="'destination[9] !== null' ? 'd-active droptarget9' : 'droptarget9'" id="target9">
                          <div class="dragcont" v-for="(box, key) in destination[9]" :key="key">
                            <span class="text-box">{{ box.name }}</span>
                          </div>
                          
                        </div>
                      </draggable>
                     </div>
                      <div class="col-sm-2 countbox">
                        <button class="btn btn-sm btn-success btn-check" @click="checkPage"><img class="img-check" src="../assets/img/check.png"/><strong><span id="check-count">CHECK</span></strong> </button>
                        <br><span id="count"></span>
                      </div>

                        <div class="columnList">
                            <draggable style="cursor:pointer;" class="list-group" v-model="lists" group="destinations" @start="drag=true" @end="drag=false">
                              <div class="list-group-item listcont" v-for="(list, key) in lists" :key="key">
                                <span class="properties" style="cursor:grabbing;">{{ list.name }}</span>
                              </div>
                            </draggable>
                        </div>
                   </div>              
          </div>
          <div class="footer">
            <button class="btn btn-target"  id="nxtbtn" @click="checkPage"><span class="text-lg">NEXT</span></button>
          </div>
        </div>    
      </div>
     <div class="d-game" v-if="page==2" style="display:block;">
        <div class="body" id="p1" ref="page1">
          <div class="d-header">
            <h3 class="font-sans text-6xl text-black text-center">You have completed this exercise</h3></br>
            Thank you for participating
          </div>
          <div class="footer">
            <button class="btn btn-target" @click="refreshPage"><span class="text-lg">TRY AGAIN</span></button>
          </div>
        </div>
      </div>
    
  </div>
   
</div>
</template>
<script>
import HelloWorld from './components/HelloWorld.vue'
import '@/assets/css/style.css'
import draggable from 'vuedraggable'
export default {
  name: 'app',
  components: {
    HelloWorld,
    draggable,
  },

  data(){
    return{
      who: null,
      page:0,
      pages:['p1','p2'],
      isNext:false,
      isPrev:true,
      isLast:false,
      // lists:["Expression-independent descriptions","Face recognition units", "Viewed-centred descriptions","Facial speech analysis",
      // "Expression analysis", "Name generation","Direct visual processing","Cognitive system","Person identity nodes"],
      lists: [
        {
          id: 1,
          name: 'Expression-independent descriptions'
        },
        {
          id: 2,
          name: 'Face recognition units'
        },
        {
          id: 3,
          name: 'Viewed-centred descriptions'
        },
        {
          id: 4,
          name: 'Facial speech analysis'
        },
        {
          id: 5,
          name: 'Expression analysis'
        },
        {
          id: 6,
          name: 'Name generation'
        },
        {
          id: 7,
          name: 'Direct visual processing'
        },
        {
          id: 8,
          name: 'Cognitive system'
        },
        {
          id: 9,
          name: 'Person identity nodes'
        }
      ],
      destination: {
        1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: []
      },
      message:'',
      counts:[],
      style:"",
      status: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false
      },
      firstbox:[],
      complete:false,
    }
  },
  methods:{
    refreshPage(){
      window.location.reload();
    },
    log: function(evt) {
      window.console.log(evt);
    },
    nextPage(){
      this.page++
    },
    checkBox(added){
      if(this.destination[1].length){
          if(this.destination[1].length > 1){
          this.lists.push(this.destination[1][1]);
          this.destination[1].pop();
          this.status[1] = true
          this.counts.push(this.destination[1][0])
        }
      }
      if(this.destination[2].length){
          if(this.destination[2].length > 1){
          this.lists.push(this.destination[2][1]);
          this.destination[2].pop();
        }
      }

      if(this.destination[3].length){
          if(this.destination[3].length > 1){
          this.lists.push(this.destination[3][1]);
          this.destination[3].pop();
        }
      }
      if(this.destination[4].length){
          if(this.destination[4].length > 1){
          this.lists.push(this.destination[4][1]);
          this.destination[4].pop();
        }
      }
      if(this.destination[5].length){
          if(this.destination[5].length > 1){
          this.lists.push(this.destination[5][1]);
          this.destination[5].pop();
        }
      }
      if(this.destination[6].length){
          if(this.destination[6].length > 1){
          this.lists.push(this.destination[6][1]);
          this.destination[6].pop();
        }
      }
      if(this.destination[7].length){
          if(this.destination[7].length > 1){
          this.lists.push(this.destination[7][1]);
          this.destination[7].pop();
          console.log("push")
        }
      }
      if(this.destination[8].length){
          if(this.destination[8].length > 1){
          this.lists.push(this.destination[8][1]);
          this.destination[8].pop();
          console.log(this.lists.id)
        }
      }
      if(this.destination[9].length){
          if(this.destination[9].length > 1){
          this.lists.push(this.destination[9][1]);
          this.destination[9].pop();
        }
      }
      
      console.log(this.lists.length)
      if(this.lists.length == 0){
        $('#nxtbtn').prop('disabled',false);
      }
    },
    checkPage(){
      var correct = 0;
      if(this.lists.length ==0 & this.complete == true){
        this.page++;
      }
      else{
        
        if(this.destination[1].length){
          if (this.destination[1][0].id == 5){
            correct++
            $('#target1').css('background-color','#AAEEAA');
          }
          else{
            $('#target1').css('background-color','#ce95a0');
          }
        }
        if(this.destination[2].length){
          if (this.destination[2][0].id == 3){
            correct++
            $('#target2').css('background-color','#AAEEAA');
          }
          else{
            $('#target2').css('background-color','#ce95a0');
          }
        }
        if(this.destination[3].length){
          if (this.destination[3][0].id == 1){
            correct++
            $('#target3').css('background-color','#AAEEAA');
          }
          else{
            $('#target3').css('background-color','#ce95a0');
          }
        }
        if(this.destination[4].length){
          if (this.destination[4][0].id == 4){
            correct++
            $('#target4').css('background-color','#AAEEAA');
          }
          else{
            $('#target4').css('background-color','#ce95a0');
          }
        }
        if(this.destination[5].length){
          if (this.destination[5][0].id == 7){
            correct++
            $('#target5').css('background-color','#AAEEAA');
          }
          else{
            $('#target5').css('background-color','#ce95a0');
          }
        }
        if(this.destination[6].length){
          if (this.destination[6][0].id == 2){
            correct++
            $('#target6').css('background-color','#AAEEAA');
          }
          else{
            $('#target6').css('background-color','#ce95a0');
          }
        }
        if(this.destination[7].length){
          if (this.destination[7][0].id == 8){
            correct++
            $('#target7').css('background-color','#AAEEAA');
          }
          else{
            $('#target7').css('background-color','#ce95a0');
          }
        }
        if(this.destination[8].length){
          if (this.destination[8][0].id == 9){
            correct++
            $('#target8').css('background-color','#AAEEAA');
          }
          else{
            $('#target8').css('background-color','#ce95a0');
          }
        }
        if(this.destination[9].length){
          if (this.destination[9][0].id == 6){
            correct++
            $('#target9').css('background-color','#AAEEAA');
          }
          else{
            $('#target9').css('background-color','#ce95a0');
          }
        }
        if(correct == 9){
          this.complete = true;
          window.setTimeout(function(){
          $('.d-active').css('background-color','#AAEEAA')
          },10000);
          $('#count').html('<span style="user-select: none;color:green;margin-left:0px;">Well done, you got them all correct &nbsp; </span>');
        }
        else{
          window.setTimeout(function(){
          $('.d-active').css('background-color','#cdcfd1')
          },1000);
          $('#count').html('<span style="user-select: none;color:red;margin-left:0px;">You got '+correct+' correct &nbsp; </span>');
        }
        console.log(correct);
        $('.list-group-item').css('background-color','#ce95a0')
         
      }
    },

    checking(){
      if(this.lists.length == 0){
        $('#nxtbtn').prop('disabled',false);
      }
    },
    lastPage(){
      if(this.counts.length == 9){
        
      }
    }
  },
}
</script>

<style>
 
  .wrong{
    background-color:lightgray;
    font-size:18px;
    font-family: arial;
  }
  .countmsg{
    color:red;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
  }
</style>
